import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import HttpUtil from "../../common/HttpUtil";
import AlertComponent from "../../common/AlertComponent";
import { PAYMENTS_API } from "../../common/Constants";
import {
  changeToINR,
  PAYMENT_STATUS_LIST_OBJECT
} from "../../common/LookupConstants";
import { getDisplayDate, convertNumberToDate } from "../../lease/DateUtil";
import TableList from "../../common/TableList";
import Can from "../../../auth/can";

class PaymentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentList: null
    };
  }

  componentDidMount() {
    this.getAllPayments();
  }

  // api failed  response alert to user
  handleApiFailed = message => {
    this.setState({
      //Default alert
      alertType: "Default",
      showAlert: true,
      alertColor: "danger",
      alertMessage: message
    });
  };

  // close alert message
  closeDefaultAlert = () => {
    this.setState({
      alertType: "",
      showAlert: false,
      alertColor: "",
      alertMessage: ""
    });
  };

  getAllPayments = () => {
    const url = PAYMENTS_API;
    HttpUtil.get(
      url,
      {},
      data => {
        this.setState({ paymentList: data });
      },
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  getName = (entity, payment) => {
    if (!payment) {
      return null;
    }
    let name = "";
    if (payment.entityType === "Individual") {
      const names = [];
      if (entity.firstName) {
        names.push(entity.firstName);
      }
      if (entity.lastName) {
        names.push(entity.lastName);
      }
      name = names.join(" ");
    } else {
      name = entity.name;
    }
    return name;
  };

  nameFormatter = (entity, payment) => {
    if (!payment) {
      return null;
    }
    return (
      <Link to={`/admin/finance/payments/view/${payment._id}`} role="button">
        {this.getName(entity, payment)}
      </Link>
    );
  };

  actionsFormater = (cell, row) => {
    if (!row) {
      return null;
    }
    let viewButton = (
      <Fragment>
        <Can do="UPDATE" on="Payment">
          {row.status !== "VOIDED" && row.paymentType === "REGULAR" ? (
            <Link
              to={`/admin/finance/payment/void/${row._id}`}
              className="list-action-btn-primary ml-2"
              role="button"
            >
              {/* <i
              className="fas fa-file-invoice-dollar action-icon pl-3"
              data-toggle="tooltip"
              data-placement="top"
              title="Void Payment"
            /> */}
              Void Payment
            </Link>
          ) : null}
        </Can>
      </Fragment>
    );

    return viewButton;
  };

  dateFormater = yyyymmdd => {
    return getDisplayDate(convertNumberToDate(yyyymmdd));
  };

  render() {
    const { paymentList } = this.state;

    const columnsPayments = [
      {
        dataField: "entity",
        text: "Name",
        sort: true,
        formatter: this.nameFormatter,
        csvFormatter: this.getName,
        filterValue: this.getName
      },
      {
        dataField: "paymentDate",
        text: "Payment Date",
        formatter: this.dateFormater,
        csvFormatter: this.dateFormater
      },
      {
        dataField: "amount",
        text: "Amount",
        formatter: changeToINR,
        classes: "text-right",
        csvType: Number
      },
      {
        dataField: "status",
        text: "Status",
        formatter: cell => PAYMENT_STATUS_LIST_OBJECT[cell] || "Unspecified",
        csvFormatter: cell => PAYMENT_STATUS_LIST_OBJECT[cell] || "Unspecified",
        filterValue: cell => PAYMENT_STATUS_LIST_OBJECT[cell] || "Unspecified"
      },
      {
        dataField: "actions",
        text: "Actions",
        isDummyField: true,
        formatter: this.actionsFormater,
        csvExport: false
      }
    ];

    const alertProps = {
      show: this.state.showAlert,
      type: this.state.alertType,
      alertColor: this.state.alertColor,
      message: this.state.alertMessage,
      close: this.closeDefaultAlert,
      confirm: this.okConfirmUpdate
    };
    return (
      <Fragment>
        <div className="row">
          <div className="col-12">
            {/* show alert message  */}
            <AlertComponent {...alertProps} />
          </div>
        </div>

        <TableList
          keyField="_id"
          columns={columnsPayments}
          data={paymentList}
          noDataIndication="No Payments found."
          sizePerPage="10"
          headerName="Payments"
          showSearchbar={true}
          customComponent={<RenderCustomButton />}
        />
      </Fragment>
    );
  }
}

export default PaymentList;

const RenderCustomButton = props => {
  return (
    <Can do="CREATE" on="Payment">
      <Link
        to="/admin/finance/payment/new"
        role="button"
        className="btn btn-sm text-white bg-pink"
      >
        New
      </Link>
    </Can>
  );
};
